/**
 * Constants for query param values on `/player/*` routes.
 *
 * The param SCHEMA lives at apps/hendrx/src/routes/player.tsx (parent route's
 * validateSearch). These constants document the recognised VALUES for those
 * params so consumers compare against named constants instead of magic strings.
 */

// Value of the `host` param when the player is embedded in an Infinity iframe.
// Used by:
//  - isFreeContentEmbedSignal / useContentSessionExchange (client) to detect Infinity context
//  - modules/xapi-events/.../processEvent.ts (server) to forward events to Infinity
export const INFINITY_HOST = 'infinity';

// Values of the `mode` param.
// Legacy signal for an exam attempt (Continue button, restricted helpers), from the proof-of-concept the
// behaviour came from. `metadata.subType` is the source now — see `isEvaluationAttemptSignal`, the one
// place both are read; this value survives only so a launcher still sending it keeps working.
export const PLAYER_MODE_EVALUATION = 'evaluation';
export const PLAYER_MODE_PREVIEW = 'preview'; // Studio preview mode (no scoring, no submission)
